<div class="card-columns">
  <div class="card" *ngFor="let block of block.content trackBy: trackByFn;" [innerHTML]="block.data.content"></div>
</div>
